import { CardInfo } from "../Subscription/CardInfo";

export class MockCardInfo implements CardInfo {
  public brand = "visa";
  public expMonth = 12;
  public expYear = 25;
  public last4 = "1234";
}
